module.exports = __webpack_public_path__ + "img/research-icon.55f7c3ad.svg";